import { useEffect, useRef } from 'react';
import { Tooltip } from 'bootstrap';

export function useTooltipRight(initialTitle) {
    const elementRef = useRef(null);
    const tooltipRef = useRef(null);

    useEffect(() => {
        if (elementRef.current) {
            tooltipRef.current = new Tooltip(elementRef.current, {
                customClass: 'tooltip-custom',
                title: initialTitle,
            });
        }

        return () => {
            tooltipRef.current?.dispose();
        };
    }, [initialTitle]);

    const setTooltipText = (text) => {
        if (tooltipRef.current) {
            tooltipRef.current.setContent({
                '.tooltip-inner': text,
            });
        }
    };

    const showTooltip = () => tooltipRef.current?.show();
    const hideTooltip = () => tooltipRef.current?.hide();

    return { elementRef, setTooltipText, showTooltip, hideTooltip };
}